import React from 'react';
import { Download, Loader2, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';
import { fetchResumeBlob } from '../../api';

const ApplicationsTable = ({ apps, loading, onDelete }) => {
  if (loading) return <div className="p-10 text-center text-slate-400"><Loader2 className="w-5 h-5 animate-spin inline" /> Loading...</div>;
  if (apps.length === 0) return <div className="p-10 text-center text-slate-400">No applications yet.</div>;
  return (
    <table className="w-full text-sm">
      <thead className="bg-slate-900/60 text-slate-400 text-xs uppercase tracking-wider">
        <tr>
          <th className="text-left px-5 py-3">Name</th>
          <th className="text-left px-5 py-3">Email</th>
          <th className="text-left px-5 py-3">Job</th>
          <th className="text-left px-5 py-3">Submitted</th>
          <th className="text-left px-5 py-3">Resume</th>
          <th className="text-right px-5 py-3">Actions</th>
        </tr>
      </thead>
      <tbody>
        {apps.map(a => (
          <tr key={a.id} className="border-t border-cyan-400/5 hover:bg-slate-900/40 align-top">
            <td className="px-5 py-4 text-white">{a.name}<div className="text-slate-400 text-xs mt-1 max-w-sm line-clamp-2">{a.cover}</div></td>
            <td className="px-5 py-4 text-cyan-300"><a href={`mailto:${a.email}`} className="hover:underline">{a.email}</a></td>
            <td className="px-5 py-4 text-slate-300">{a.job_title}</td>
            <td className="px-5 py-4 text-slate-400 text-xs">{new Date(a.created_at).toLocaleString()}</td>
            <td className="px-5 py-4">
              {a.resume_filename ? (
                <Button onClick={() => fetchResumeBlob(a.id, a.resume_filename)} variant="outline" className="h-8 border-cyan-400/40 bg-transparent hover:bg-cyan-400/10 text-cyan-300">
                  <Download className="w-3.5 h-3.5 mr-1" /> {a.resume_filename}
                </Button>
              ) : <span className="text-slate-500 text-xs">&mdash;</span>}
            </td>
            <td className="px-5 py-4 text-right">
              <Button onClick={() => onDelete && onDelete(a)} variant="outline" className="h-8 border-red-900/40 bg-transparent hover:bg-red-950/40 text-red-300"><Trash2 className="w-3.5 h-3.5" /></Button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ApplicationsTable;
